import { Injectable } from '@angular/core';

export interface LastSupportContext {
  resellerId: number;
  organizationName: string;
  unitHash: string;
  savedAt: string;
}

const STORAGE_KEY = 'ladderSupportContext';
const EXPIRATION_DAYS = 30;

@Injectable({
  providedIn: 'root',
})
export class SupportStorageService {
  save(context: LastSupportContext): void {
    context.savedAt = new Date().toISOString();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(context));
  }

  load(): LastSupportContext | null {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    try {
      const context: LastSupportContext = JSON.parse(raw);
      const savedAt = new Date(context.savedAt);
      const now = new Date();
      const diffDays = (now.getTime() - savedAt.getTime()) / (1000 * 60 * 60 * 24);

      if (diffDays > EXPIRATION_DAYS) {
        this.clear();
        return null;
      }

      return context;
    } catch {
      this.clear();
      return null;
    }
  }

  clear(): void {
    localStorage.removeItem(STORAGE_KEY);
  }
}
